import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import SyncIcon from '@mui/icons-material/Sync';
import { Box, Button, SxProps, Theme } from '@mui/material';

import { getLayoutHierarchyAccessLevel } from '../../../../store/selectors/layoutModeSelectors';
import { useAppSelector } from '../../../hooks';

export function SyncElevationButton(props: {
  sx?: SxProps<Theme>;

  disabled?: boolean;

  /**
   * required: whether the elevation is currently synchronized or not
   */
  synchronized: boolean;

  /**
   * optional: instructs the button to use plural terminology. defaults to `false`
   */
  plural?: boolean;

  /**
   * optional: whether the button should be visible. defaults to `true`
   */
  visible?: boolean;

  /**
   * required: will be called when user requests to synchronize the target elevation(s) to the level elevation(s)
   */
  onSynchronize: () => void;
}) {
  const hierarchyAccess = useAppSelector(getLayoutHierarchyAccessLevel);

  if (props.visible === false || !hierarchyAccess.write) return null;

  const subject = props.plural ? 'Elevations' : 'Elevation';
  const verb = props.plural ? 'match' : 'matches';

  return (
    <Box sx={[{ display: 'flex', justifyContent: 'center' }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
      {props.synchronized ? (
        <Button variant="outlined" startIcon={<CheckIcon />} disabled={props.disabled}>
          {subject} {verb} Level Settings
        </Button>
      ) : (
        <Button
          variant="outlined"
          startIcon={<SyncIcon />}
          color="warning"
          disabled={props.disabled}
          onClick={props.onSynchronize}
        >
          Set {subject} From Level
        </Button>
      )}
    </Box>
  );
}
